import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { isNativeCapacitor } from "@/lib/platform";

// Catches khanaqin://auth?token=... (social login returning from the in-app browser)
export const AuthDeepLinkListener = () => {
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!isNativeCapacitor()) return;
    let handle;
    (async () => {
      const { App } = await import("@capacitor/app");
      handle = await App.addListener("appUrlOpen", async ({ url }) => {
        if (!url || !url.startsWith("khanaqin://auth")) return;
        const params = new URL(url.replace("khanaqin://", "https://x/")).searchParams;
        const token = params.get("token");
        if (!token) return;
        try { localStorage.setItem("kh_token", token); } catch { /* ignore */ }
        try { const { Browser } = await import("@capacitor/browser"); await Browser.close(); } catch { /* ignore */ }
        await refresh();
        toast.success("تم تسجيل الدخول");
        const next = params.get("next") || "/";
        nav(next.startsWith("/") ? next : "/");
      });
    })();
    return () => { handle?.remove?.(); };
  }, [refresh, nav]);

  return null;
};
